import { ParsedChartProps } from 'types'
import { useTheme } from 'utils'
import GoogleChart from '../GoogleChart'
import {
  customColor,
  defaultChartProps,
  makeChartData,
  makeDefaultChartOptions,
} from '../chartUtils'

export default function PieChart({onSelect, ...props}: ParsedChartProps) {
  const { theme: colorMode } = useTheme()

  const options = {
    ...makeDefaultChartOptions(props),
    chartArea: {
      height: '90%',
      width: '90%',
    },
    pieHole: 0.4,
    legend: {
      position: 'labeled',
      textStyle: {
        color: colorMode === 'light' ? '#333' : '#FFF',
      },
    },
    pieSliceBorderColor: '',
    slices: props.data.map(r => {
      const label = r[props.categories[0]]
      return { color: customColor(label) }
    }),
  }

  return (
    <GoogleChart
      {...defaultChartProps}
      chartType="PieChart"
      data={makeChartData(props)}
      options={options}
      onSelect={onSelect}
    />
  )
}
